import { useTranslation } from 'react-i18next';
import { useOrganization } from '@clerk/clerk-react';

interface Props {
  name: string;
  onNameChange: (name: string) => void;
}

export default function AccountTab({ name, onNameChange }: Props) {
  const { t } = useTranslation();
  const { organization } = useOrganization();

  return (
    <div className="max-w-md space-y-4">
      <div>
        <label className="block text-sm text-white/60 mb-1">{t('name')}</label>
        <input
          type="text"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          className="w-full bg-white/5 border border-white/20 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-brand-purple"
        />
      </div>

      <div>
        <label className="block text-sm text-white/40 mb-1">{t('email')}</label>
        <div className="text-white/30 text-sm bg-white/5 rounded-lg px-4 py-2 border border-white/10">
          {organization?.slug ?? '—'} (managed by Clerk)
        </div>
      </div>
    </div>
  );
}
